import { ToastContainer } from "react-toastify";
import "../Register.css";
import { RegisterProvider, useRegister } from "./RegisterContext";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import RegisterStep3 from "./RegisterStep3";
import EmailVerificationModal from "./EmailVerificationModal";
import { useTranslation } from "react-i18next";
import 'react-toastify/dist/ReactToastify.css';
import { Capacitor } from "@capacitor/core";


export default function Register() {

  const { t } = useTranslation();

  return (
    <RegisterProvider>
      <ToastContainer position="top-right" />
      <main className="register-page">
        {!Capacitor.isNativePlatform() && (
          <div className="register-topbar">
            <a href="/" className="register-back-home">
              {t("loginn.backHome")}
            </a>
          </div>
        )}
        <div className="register-container">
          <section className="register-card">
            <RegisterJourney />
            <RegisterStep1 />
            <RegisterStep2 />
            <RegisterStep3 />
            <EmailVerificationModal />
          </section>
        </div>
      </main>
    </RegisterProvider>
  );
}

function RegisterJourney() {
  const { step } = useRegister();

  return (
    <div className="register-journey" aria-label="Progression de l'inscription">
      {[
        [1, "Profil"],
        [2, "Informations"],
        [3, "Vérification"],
      ].map(([number, label]) => (
        <div key={number} className={`register-journey-step ${step >= number ? "is-active" : ""} ${step === number ? "is-current" : ""}`}>
          <span>{number}</span>
          <small>{label}</small>
        </div>
      ))}
    </div>
  );
}
